import React from 'react';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import moment from 'moment';
import {zeroFill} from 'utils/Utils';

const INACTIVITY_ALERT = 1800;  // 30 minutes

export default function HealthCheckIndicator({data, size}) {
    size = size || '2xs';
    let alpha = 0;
    let color = '#ccc';
    let icon = 'fa-circle';
    let title = 'Offline';
    const minTimestamp = Math.min(Infinity, ...Object.values(data || {}).map(moduleData => moment(moduleData.timestamp).unix()));
    const maxTimestamp = Math.max(-Infinity, ...Object.values(data || {}).map(moduleData => moment(moduleData.timestamp).unix()));
    if (maxTimestamp > 0) {
        const timestampsDifference = maxTimestamp - minTimestamp;  // seconds
        const maxToNowDifference = Math.max(moment().unix() - maxTimestamp, 0);  // seconds
        if (maxToNowDifference <= 86400) {  // 24 hours
            alpha = 55 + Math.round(200 * (1 - maxToNowDifference / 86400));
            color = '#00ff00' + zeroFill(alpha.toString(16), 2);
        }
        title = 'Last seen ' + moment.duration(-maxToNowDifference, 'seconds').humanize(true);
        if (timestampsDifference > INACTIVITY_ALERT) {
            color = '#f00';
            icon = 'fa-circle-exclamation';
            for (const [moduleName, moduleData] of Object.entries(data || {})) {
                if (moment(moduleData.timestamp).unix() === minTimestamp) {
                    title += (
                        `. Check the logs of module "${moduleName}", which has been inactive for ` +
                        moment.duration(timestampsDifference, 'seconds').humanize(false) + '.'
                    );
                    break;
                }
            }
        }
    }
    return (
        <OverlayTrigger placement="top" overlay={<Tooltip>{title}</Tooltip>}>
            <FontAwesomeIcon icon={icon} size={size} color={color} style={{marginRight: '6px'}} />
        </OverlayTrigger>
    );
};
